var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PanelTabs',{attrs:{"items":_vm.itemsToShow,"back":_vm.items.length > 1,"isLoading":_vm.isLoading},on:{"go-back":function($event){return _vm.items.pop()},"add-item":_vm.data.addItem,"search":_vm.search}})
}
var staticRenderFns = []

export { render, staticRenderFns }